var _path, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChieldAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4728 34.2706L31.1505 38.2624C27.802 40.7737 23.198 40.7737 19.8495 38.2624L14.5272 34.2706C10.733 31.425 8.5 26.959 8.5 22.2163V12.2672C8.5 10.1868 10.1865 8.50024 12.267 8.50024H38.733C40.8135 8.50024 42.5 10.1868 42.5 12.2672V22.2163C42.5 26.959 40.267 31.425 36.4728 34.2706Z",
    stroke: "url(#paint0_linear_1146_1585)",
    strokeWidth: 3.19,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21.25,
    r: 2.125,
    fill: "url(#paint1_linear_1146_1585)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.125,
    cy: 21.25,
    r: 2.125,
    fill: "url(#paint2_linear_1146_1585)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.875,
    cy: 21.25,
    r: 2.125,
    fill: "url(#paint3_linear_1146_1585)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1146_1585",
    x1: 8.5,
    y1: 25.5002,
    x2: 42.5,
    y2: 25.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1146_1585",
    x1: 23.375,
    y1: 21.25,
    x2: 27.625,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1146_1585",
    x1: 17,
    y1: 21.25,
    x2: 21.25,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1146_1585",
    x1: 29.75,
    y1: 21.25,
    x2: 34,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA6C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E66079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA59A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74DD7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChieldAlt);
export default __webpack_public_path__ + "static/media/Chield_alt.a10ed7c7c10a81762f99acc3a1d6f0ee.svg";
export { ForwardRef as ReactComponent };